/* eslint-disable react-hooks/exhaustive-deps, no-unused-vars, eqeqeq, no-lone-blocks */
import logger from '../../../utils/logger';
import { useCallback } from 'react';
import api, {
  addFavProcess,
  checkRecordWithGetLinkDraftData,
  deleteExistingRole,
  getdataByNodeId,
  removeFavProcess,
  saveProcessInfo,
  editorialPublishAPI,
  contentChangeRequest,
  checkParentPublishRecords,
} from '../../../api/api';
import CustomAlert from '../../../components/CustomAlert';
import { getLevelKey } from '../../../utils/getLevel';
import { buildBreadcrumbs } from '../../../utils/buildBreadcrumbs';
import { buildProcessPath } from '../../../routes/buildProcessPath';
import { getLocalPositionInsideContainer } from '../../../utils/swimlaneUtils';
import { reconnectEdge } from '@xyflow/react';

export const useSwimlaneModelHandlers = ({
  state,
  currentLevel,
  currentParentId,
  processId,
  LoginUser,
  addNode,
  fetchNodes,
  goToProcess,
  addBreadcrumb,
  removeBreadcrumbsAfter,
  langMap,
  t,
  navigate,
  fixedPos,
  id,
  refetch,
  safeRemainingHeight,
}) => {
  const {
    windowSize,
    setWindowSize,
    title,
    Settitle,
    ParentPageGroupId,
    SetParentPageGroupId,
    showPublishPopup,
    setShowPublishPopup,
    showEditorialPopup,
    setShowEditorialPopup,
    showContentPopup,
    setShowContentPopup,
    user,
    setUser,
    position,
    setPosition,
    hasUnsavedChanges,
    setHasUnsavedChanges,
    options,
    setOptions,
    isPopupOpen,
    setIsPopupOpen,
    isCheckboxPopupOpen,
    setIsCheckboxPopupOpen,
    LinknodeList,
    setLinknodeList,
    isexistingroleCheckboxPopupOpen,
    setIsexistingroleCheckboxPopupOpen,
    LinkexistingRole,
    setLinkexistingRole,
    selectedLinknodeIds,
    setSelectedLinknodeIds,
    selectedexistigrolenodeId,
    setSelectedexistingrolenodeId,
    getDraftedDate,
    setDraftedDate,
    KeepOldPosition,
    setKeepOldPosition,
    isFavorite,
    setIsFavorite,
    process_img,
    setprocess_img,
    selectedTitle,
    setSelectedTitle,
    showTranslationPopup,
    setShowTranslationPopup,
    translationDefaults,
    setTranslationDefaults,
    selectedGroupId,
    setSelectedGroupId,
    ChildNodes,
    setChiledNodes,
    contextMenu,
    setContextMenu,
    MenuVisible,
    setMenuVisible,
    selectedNode,
    setSelectedNode,
    roleGroupEditData,
    setRoleGroupEditData,
    selectedNodeId,
    setSelectedNodeId,
    selectedNodefreetextId,
    setSelectedNodefreetextId,
    showVersionPopup,
    setShowVersionPopup,
    versionPopupPayload,
    setversionPopupPayload,
    processDefaultlanguage_id,
    setprocessDefaultlanguage_id,
    OriginalDefaultlanguge_id,
    setOriginalDefaultlanguge_id,
    supportedLanguages,
    setSupportedLanguages,
    selectedEdge,
    setSelectedEdge,
    getPublishedDate,
    setgetPublishedDate,
    revisionData,
    setrevisionData,
    detailschecking,
    setdetailschecking,
    nodes,
    setNodes,
    searchQuery,
    setSearchQuery,
    ExistingrolesearchQuery,
    setExistingrolesearchQuery,
    checkpublish,
    Setcheckpublish,
    showRoleGroupModal,
    setShowRoleGroupModal,
    showAssignOwnerModal,
    setShowAssignOwnerModal,
    activeRoleForOwner,
    setActiveRoleForOwner,
    selectedEdgeInfoForFreeText,
    setSelectedEdgeInfoForFreeText,
    edges,
    setEdges,
    isModalOpen,
    setIsModalOpen,
    modalText,
    setModalText,
    modalPosition,
    setModalPosition,
  } = state;

  const fetchExistingRoles = async () => {
    try {
      const levelParam = 'level0';
      const user_id = user ? user.id : LoginUser?.id;
      const Process_id = id;
      const data = await api.getexistingrole(levelParam, parseInt(user_id), Process_id);
      const filteredNodes = data.AllexistingRole.filter((node) => node.node_id !== currentParentId);
      setLinkexistingRole(filteredNodes);
    } catch (error) {
      logger.error('Proactive role fetch error:', error);
    }
  };

  const handleNodeClick = useCallback((event, node) => {
    setSelectedEdge(null);
    setIsexistingroleCheckboxPopupOpen(false);
    setSelectedNodeId(node.id);
    handleClosePopup();

    // Since handleClosePopup no longer clears these, we do it here
    setSelectedNode(null);
    setdetailschecking(null);

    setOptions([]);
    setIsModalOpen(false);
    setIsCheckboxPopupOpen(false);
  }, []);

  const handleClosePopup = () => {
    setContextMenu(null);
    setMenuVisible(false);
  };

  const handleSaveNodes = async (savetype) => {
    const payload = {
      savetype,
      ...versionPopupPayload,
    };

    const Level = getLevelKey(currentLevel, currentParentId);

    const user_id = user && user.id;
    const Process_id = id && id;
    const datasavetype = savetype;
    const LoginUserId = LoginUser ? LoginUser.id : null;

    try {
      if (versionPopupPayload) {
        await saveProcessInfo(payload);
      }

      await api.saveNodes({
        Level,
        user_id,
        Process_id,
        datasavetype,
        LoginUserId,
        nodes: ChildNodes.map(
          ({
            id,
            data,
            type,
            position,
            draggable,
            animated,
            measured,
            page_title,
            parentNode,
            status,
            page_group_id,
          }) => ({
            id,
            data,
            type,
            position,
            draggable,
            animated,
            measured,
            page_title,
            parentNode,
            status,
            page_group_id,
          })
        ),
        edges: edges.map(
          ({
            id,
            source,
            target,
            markerEnd,
            animated,
            sourceHandle,
            targetHandle,
            page_title,
            status,
            type,
            data,
          }) => ({
            id,
            source,
            sourceHandle,
            target,
            targetHandle,
            markerEnd,
            animated,
            page_title,
            status,
            type,
            data,
          })
        ),
      });

      const msgT = t('nodes_saved_successfully');
      const event = new CustomEvent('modelSaved', { detail: { message: msgT || 'Model saved' } });
      window.dispatchEvent(event);
      setHasUnsavedChanges(false);
    } catch (error) {
      logger.error('Error saving nodes:', error);
    }
  };

  const saveDetails = (details) => {
    const langKey = langMap[processDefaultlanguage_id] || 'EN';

    setChiledNodes((nodes) =>
      nodes.map((node) =>
        node.node_id === selectedNodeId
          ? {
              ...node,
              data: {
                ...node.data,
                label: details?.title,

                details: {
                  ...node.data.details,
                  ...details,
                },

                translations: {
                  ...(node.data.translations || {}),
                  [langKey]: details?.title || '',
                },
              },
            }
          : node
      )
    );

    setHasUnsavedChanges(true);
    setSelectedNodeId(null);
  };

  const translation = () => {
    const node = ChildNodes.find((n) => n.id === selectedNodeId);

    if (node) {
      const defaults = supportedLanguages.reduce((acc, langId) => {
        const langKey = langMap[langId] || `lang_${langId}`;
        acc[langKey] = node.data?.translations?.[langKey] || '';
        return acc;
      }, {});

      setTranslationDefaults(defaults);
      setShowTranslationPopup(true);
    }
  };

  const handleDeleteNode = async () => {
    if (selectedNode) {
      CustomAlert.confirm(
        t('delete_node'),
        t('are_you_sure_you_want_to_delete_this_node'),
        async () => {
          if (selectedNode.type === 'SwimlineRightsideBox' && selectedNode.data?.link) {
            try {
              const Process_id = selectedNode?.process_id;
              const PageGroupId = selectedNode?.page_group_id;
              const parentId = selectedNode?.parentId;
              const link = selectedNode.data?.link;

              const deleteresponse = await deleteExistingRole(
                Process_id,
                PageGroupId,
                parentId,
                link
              );
              if (deleteresponse.status) {
                CustomAlert.toast(t(deleteresponse.message));
              }
            } catch (error) {
              logger.error('delete existiong role time error:', error);
            }
          }
          const nodeToRemoveId = selectedNode.id;

          // Identify all edges connected to the node being deleted
          const edgesToDelete = edges.filter(
            (edge) =>
              String(edge.source) === String(nodeToRemoveId) ||
              String(edge.target) === String(nodeToRemoveId)
          );

          // Identify all character nodes (labels) linked to these edges
          const labelIdsToRemove = ChildNodes.filter((node) => {
            if (!node.data?.edgeId && !node.data?.sourceNodeId) return false;
            return edgesToDelete.some(
              (edge) =>
                String(edge.id) === String(node.data.edgeId) ||
                (String(edge.source) === String(node.data.sourceNodeId) &&
                  String(edge.target) === String(node.data.targetNodeId) &&
                  String(edge.sourceHandle || '') === String(node.data.sourceHandle || '') &&
                  String(edge.targetHandle || '') === String(node.data.targetHandle || ''))
            );
          }).map((node) => node.id);

          setChiledNodes((nodes) =>
            nodes.filter(
              (node) =>
                String(node.id) !== String(nodeToRemoveId) && !labelIdsToRemove.includes(node.id)
            )
          );
          setEdges((eds) =>
            eds.filter(
              (edge) =>
                String(edge.source) !== String(nodeToRemoveId) &&
                String(edge.target) !== String(nodeToRemoveId)
            )
          );
          setHasUnsavedChanges(true);
        },
        null,
        t('yes_confirm') || 'Yes, confirm!',
        t('Cancel') || 'Cancel'
      );
    }
  };

  const handleNodeRightClick = (event, node) => {
    event.preventDefault();
    event.stopPropagation();
    setSelectedEdge(null);
    if (node.page_title === 'Swimlane') {
      setOptions([]);
      if (node.node_id) {
        setSelectedNodeId(node.node_id);
      } else {
        setSelectedNodeId(node.id);
      }

      setdetailschecking(node);
      event.preventDefault();
      if (node?.data?.isRoleGroup) {
        setRoleGroupEditData(node.data);
      } else {
        setRoleGroupEditData(null);
      }
      setSelectedNode(node);
      setPosition({ x: event.clientX, y: event.clientY });
      setMenuVisible(true);
      const popupHeight = 150;
      const screenHeight = window.innerHeight;
      let newY = event.clientY;
      if (event.clientY + popupHeight > screenHeight) {
        newY = event.clientY - popupHeight;
      }
      setContextMenu({
        x: event.clientX,
        y: newY,
        nodeId: node.id,
      });
    } else {
      const [, row, col] = node.row_id.split('_').map(Number);

      let options = [];

      // Determine options based on the node
      if (row === 6 && col === 0) {
        options = [];
      } else if (col === 0 && row < 6) {
        options = [
          { label: t('add_role'), value: 'Add Role' },
          {
            label: `${t('add_existing_role')}`,
            value: 'Add existing role',
          },
        ];
      } else if (row === 6 && col > 0) {
        options = [{ label: t('add_process'), value: 'Add Process' }];
      } else {
        options = [
          { label: t('add_activity'), value: 'Add Activity' },
          { label: t('add_decision'), value: 'Add Decision' },
          { label: t('add_sticky_note'), value: 'Add Sticky Note' },
        ];
      }
      setPosition({ x: event.clientX, y: event.clientY });
      setOptions(options);
      setSelectedGroupId(node.id);
      setSelectedNode(node);

      // 🔥 Reset role group edit data when right-clicking grid cells
      setRoleGroupEditData(null);
      setSelectedNodeId(null);

      // Add "Add Role Group" if vertical header
      if (col === 0 && row < 6) {
        setOptions((prev) => [...prev, { label: t('add_role_group'), value: 'Add Role Group' }]);
      }
    }
  };

  const handleSaveRoleGroup = (data) => {
    setShowRoleGroupModal(false);

    // Check if we are editing an existing node
    const isEditing = selectedNode?.data?.isRoleGroup;

    const newNodeData = {
      label: data.groupName,
      isRoleGroup: true,
      roles: data.roles,
      translations: data.translations,
      details: {
        title: data.groupName,
        content: '',
      },
    };

    if (isEditing) {
      setChiledNodes((nds) =>
        nds.map((node) =>
          node.id === selectedNode.id ? { ...node, data: { ...node.data, ...newNodeData } } : node
        )
      );
      setHasUnsavedChanges(true);
    } else {
      addNode('SwimlineRightsideBox', '', '', newNodeData);
    }

    // Propagate changes from inside Group back to standalone roles on the board
    const langKey = langMap[processDefaultlanguage_id] || 'EN';
    setChiledNodes((nds) => {
      let updatedNodes = [...nds];
      data.roles.forEach((updatedRole) => {
        updatedNodes = updatedNodes.map((node) => {
          // Check if node is a standalone role matching the updated role ID (or linked role)
          const isMatch = node.id === updatedRole.id || node.data?.link === updatedRole.id;
          if (isMatch && node.type === 'SwimlineRightsideBox' && !node.data?.isRoleGroup) {
            const newTitle = updatedRole.translations?.[langKey] || node.data?.details?.title;
            return {
              ...node,
              data: {
                ...node.data,
                owner: updatedRole.owner,
                translations: {
                  ...(node.data.translations || {}),
                  ...(updatedRole.translations || {}),
                },
                details: {
                  ...(node.data.details || {}),
                  title: newTitle,
                },
              },
            };
          }
          return node;
        });
      });
      return updatedNodes;
    });
  };

  const switchNodeType = (type) => {
    if (selectedNodeId) {
      setChiledNodes((nds) =>
        nds.map((node) =>
          node.id === selectedNodeId
            ? {
                ...node,
                type: type,
                data: {
                  ...node.data,
                  shape: type,
                },
              }
            : node
        )
      );
      setHasUnsavedChanges(true);
    }
  };

  const linkExistingmodel = async () => {
    const existinglink = ChildNodes.find((node) => node.node_id === selectedNodeId);
    if (existinglink?.data?.processlink) {
      setSelectedLinknodeIds(existinglink?.data?.processlink);
    } else {
      setSelectedLinknodeIds([]);
    }

    const user_id = user ? user.id : null;
    const Process_id = id ? id : null;
    const data = await api.getallpublishObject_Tolinkexistingmodel(parseInt(user_id), Process_id);
    const filteredNodes = data.nodes.filter(
      (node) => node.type !== 'StickyNote' && node.node_id !== currentParentId
    );

    setLinknodeList(filteredNodes);
    setIsCheckboxPopupOpen(true);
  };

  const AddexistingRole = async () => {
    const levelParam = 'level0';
    const user_id = user ? user.id : null;
    const Process_id = id ? id : null;
    const data = await api.getexistingrole(levelParam, parseInt(user_id), Process_id);

    const filteredNodes = data.AllexistingRole.filter((node) => node.node_id !== currentParentId);
    setLinkexistingRole(filteredNodes);
    setIsexistingroleCheckboxPopupOpen(true);
  };

  const handleCheckboxChange = (nodeId, label) => {
    setSelectedLinknodeIds(nodeId);
    setSelectedTitle(label);
  };

  const handleexistingroleCheckboxChange = (nodeId) => {
    setSelectedexistingrolenodeId(nodeId);
  };

  const handleSaveExistingRole = () => {
    if (selectedexistigrolenodeId) {
      const parsedDataExistingrole = LinkexistingRole.map((item) => ({
        ...item,
        data: typeof item.data === 'string' ? JSON.parse(item.data) : item.data,
      }));

      const selectedNode = parsedDataExistingrole.find(
        (item) => item.node_id === selectedexistigrolenodeId
      );

      if (!selectedNode) return;

      // Clone existing node data
      const newNodeData = {
        ...selectedNode.data,
        link: selectedexistigrolenodeId,
      };
      setIsexistingroleCheckboxPopupOpen(false);

      // Add new node using cloned data
      addNode('SwimlineRightsideBox', '', '', newNodeData);

      setSelectedexistingrolenodeId('');
    }
  };

  const saveSelectedNodes = async () => {
    if (selectedLinknodeIds && selectedTitle) {
      let hasNextLevel = false;

      const match = selectedLinknodeIds.match(/level(\d+)/i);
      const extractedLevel = match ? parseInt(match[1]) : currentLevel;

      // 🔹 Increment level
      const newLevel = extractedLevel + 1;
      const levelParam = `level${newLevel}_${selectedLinknodeIds}`;
      try {
        const check = await api.checkRecord(levelParam, processId);
        hasNextLevel = check?.status === true;
      } catch (e) {
        logger.error('checkRecord error', e);
      }

      setChiledNodes((nds) =>
        nds.map((node) => {
          if (node.id === selectedNodeId) {
            return {
              ...node,
              data: {
                ...node.data,
                processlink: selectedLinknodeIds,
                hasNextLevel,
                details: {
                  ...node.data.details,
                  title: selectedTitle || node.data.details?.title || 'Default Title',
                },
              },
            };
          }
          return node;
        })
      );

      setIsCheckboxPopupOpen(false);
      setHasUnsavedChanges(true);
    } else {
      CustomAlert.warning(t('warning') || 'Warning', t('please_select_a_node_before_saving'));
    }
  };

  const removeExistingLink = () => {
    if (!selectedNodeId) return;

    CustomAlert.confirm(
      t('are_you_sure'),
      t('this_will_remove_the_link'),
      () => {
        setChiledNodes((nds) =>
          nds.map((node) => {
            if (node.id === selectedNodeId || node.parentId === selectedNodeId) {
              return {
                ...node,
                data: {
                  ...node.data,
                  processlink: null, // remove link
                  details: {
                    ...(node.data.details || {}),
                    title: '', // clear title too
                  },
                },
              };
            }
            return node;
          })
        );

        setHasUnsavedChanges(true);

        CustomAlert.success(
          t('link_removed'),
          t('link_and_title_have_been_removed_from_the_selected_node_and_its_child_nodes')
        );
      },
      () => {
        CustomAlert.info(t('cancelled'), t('no_changes_were_made'));
      }
    );
  };

  const openExistingModel = async (nodelink) => {
    const confirmcondition = await handleExitBack(); // Wait for confirmation
    if (confirmcondition) {
      if (nodelink) {
        try {
          const response = await getdataByNodeId(nodelink, 'draft');
          if (response.data && response.data.length > 0) {
            const user_id = response.data[0].user_id;
            const Process_id = response.data[0].process_id;
            const id = response.data[0].process_id;

            let newLevel = 1;
            if (nodelink !== null) {
              const match = nodelink.match(/^level(\d+)/);
              if (match && match[1]) {
                const currentLevel = parseInt(match[1], 10);
                newLevel = currentLevel + 1;
              }
            }

            const levelParam =
              nodelink !== null ? `level${newLevel}_${nodelink}` : `level${newLevel}`;

            const nodeData = await checkRecordWithGetLinkDraftData(
              levelParam,
              parseInt(user_id),
              Process_id,
              nodelink
            );

            if (nodeData.status === true) {
              removeBreadcrumbsAfter(1);
              const breadcrumbs = buildBreadcrumbs(nodeData.allNodes, nodeData.ids, Process_id);
              breadcrumbs.forEach(({ label, path, state }) => {
                addBreadcrumb(label, path, state);
              });

              const mode = 'draft';
              const view = nodeData.Page_Title === 'Swimlane' ? 'swimlane' : 'map';

              goToProcess({
                mode,
                view,
                processId: id,
                level: newLevel,
                parentId: nodelink,
              });
            } else {
              CustomAlert.warning(
                t('warning') || 'Warning',
                t('first_create_next_model_of_this_existing_model')
              );
            }
          } else {
            logger.error('No data found in response.data');
          }
        } catch (error) {
          logger.error('Error fetching link data:', error);
        }
      }
    }
  };

  const handleTextSubmit = (enteredText) => {
    setIsModalOpen(false);

    if (!enteredText) return;

    setHasUnsavedChanges(true);

    const currentLangId = processDefaultlanguage_id;
    const langKey = langMap[Number(currentLangId)] || 'EN';

    if (selectedNodefreetextId) {
      // Update existing node
      setChiledNodes((prevNodes) => {
        return prevNodes.map((node) => {
          if (node.id === selectedNodefreetextId) {
            const updatedTranslations = {
              ...(node.data.translations || {}),
              [langKey]: enteredText,
            };

            return {
              ...node,
              data: {
                ...node.data,
                label: enteredText,
                translations: updatedTranslations,
              },
            };
          }
          return node;
        });
      });

      setSelectedNodefreetextId(null);
    } else {
      // Create new FreeText node with translations
      const translations = { [langKey]: enteredText };
      const edgeData = selectedEdgeInfoForFreeText
        ? {
            edgeId: selectedEdgeInfoForFreeText.edgeId,
            sourceNodeId: selectedEdgeInfoForFreeText.source,
            targetNodeId: selectedEdgeInfoForFreeText.target,
            sourceHandle: selectedEdgeInfoForFreeText.sourceHandle,
            targetHandle: selectedEdgeInfoForFreeText.targetHandle,
          }
        : {};

      addNode(
        'FreeText',
        { x: modalPosition.x, y: modalPosition.y - 20 },
        enteredText,
        { ...edgeData, translations },
        selectedEdgeInfoForFreeText?.edgeId
      );
      setSelectedEdgeInfoForFreeText(null);
    }
  };

  const UpdateText = () => {
    const data = ChildNodes.find((node) => node.id === selectedNodeId);

    setSelectedNodefreetextId(data.id);
    setModalText(data.data.label || '');
    setIsModalOpen(true);
  };

  const handlePopupAction = (action) => {
    const { x, y } = fixedPos;

    const { edgeId, source, target, sourceHandle, targetHandle } = contextMenu;
    const edgeData = {
      edgeId,
      sourceNodeId: source,
      targetNodeId: target,
      sourceHandle,
      targetHandle,
    };

    if (action === 'Yes') {
      addNode('Yes', { x: x, y: y - 20 }, '', edgeData, edgeId);
    } else if (action === 'No') {
      addNode('No', { x: x, y: y - 20 }, '', edgeData, edgeId);
    } else if (action === 'addFreeText') {
      setIsModalOpen(true);
      setModalText('');
      setModalPosition({ x, y });
      setSelectedEdgeInfoForFreeText(contextMenu);
    } else if (action === 'addDetails') {
      setIsPopupOpen(true);
    } else if (action === 'Add Role Group') {
      setShowRoleGroupModal(true);
    }
    setContextMenu(null);
    setSelectedEdge(null);
  };

  const handleAssignOwnerAction = (role) => {
    setActiveRoleForOwner(role);
    setShowAssignOwnerModal(true);
  };

  const deleteEdge = () => {
    const edgeToDelete = selectedEdge;
    const edgeIdToDelete = edgeToDelete.id;

    setEdges((eds) => eds.filter((e) => e.id !== edgeIdToDelete));
    setChiledNodes((prevNodes) =>
      prevNodes.filter((node) => {
        if (!node.data?.edgeId && !node.data?.sourceNodeId) return true;
        return !(
          String(node.data.edgeId) === String(edgeIdToDelete) ||
          (String(node.data.sourceNodeId) === String(edgeToDelete.source) &&
            String(node.data.targetNodeId) === String(edgeToDelete.target) &&
            String(node.data.sourceHandle || '') === String(edgeToDelete.sourceHandle || '') &&
            String(node.data.targetHandle || '') === String(edgeToDelete.targetHandle || ''))
        );
      })
    );
    setSelectedEdge(null);
    setHasUnsavedChanges(true);
  };

  const onReconnect = (oldEdge, newConnection) => {
    setEdges((prevEdges) => reconnectEdge(oldEdge, newConnection, prevEdges));
    setHasUnsavedChanges(true);
  };

  const onEdgeClick = (event, edge) => {
    event.preventDefault();
    event.stopPropagation();
    const { clientX, clientY } = event;
    setPosition({ x: clientX, y: clientY });
    setMenuVisible(false);
    setOptions([]);
    setSelectedEdge(edge);
    setContextMenu({
      x: event.clientX,
      y: event.clientY,
      edgeId: edge.id,
      source: edge.source,
      target: edge.target,
      sourceHandle: edge.sourceHandle,
      targetHandle: edge.targetHandle,
    });
  };

  const handleOptionClick = (option) => {
    if (option === 'Add Role') {
      addNode('SwimlineRightsideBox');
    } else if (option === 'Add existing role') {
      AddexistingRole();
    } else if (option === 'Add Activity') {
      addNode('box');
    } else if (option === 'Add Decision') {
      addNode('diamond');
    } else if (option === 'Add Process') {
      addNode('progressArrow');
    } else if (option === 'Add Role Group') {
      setShowRoleGroupModal(true);
    } else if (option === 'Add Sticky Note') {
      const pos = getLocalPositionInsideContainer(position.x, position.y);
      addNode('StickyNote', pos);
    }

    setOptions([]);
  };

  const handleContextMenu = (event) => {
    event.preventDefault();
    setMenuVisible(false);
    setOptions([]);

    const flowContainer = document.querySelector('.publishcontainer');
    if (!flowContainer) return;

    const { left, top } = flowContainer.getBoundingClientRect();
    const x = event.clientX - left;
    const y = event.clientY - top;

    const totalRows = 7;
    const totalColumns = 11;
    const rflight = document.querySelector('.app-header');
    const rfWidth = rflight ? Math.max(1416, rflight.offsetWidth) : 1416;
    const groupWidth = rfWidth / totalColumns;
    const groupHeight = safeRemainingHeight / totalRows - 0.3;

    const col = Math.floor(x / groupWidth);
    const row = Math.floor(y / groupHeight);

    if (row >= 0 && row < totalRows && col >= 0 && col < totalColumns) {
      const gridNodeId = `group-${row * totalColumns + col}`;
      const gridNode = nodes.find((n) => n.id === gridNodeId);
      if (gridNode) {
        handleNodeRightClick(event, gridNode);
      }
    }
  };

  const handleExitBack = async () => {
    if (!hasUnsavedChanges) return true;

    return new Promise((resolve) => {
      CustomAlert.confirmExit(
        async () => {
          await handleSaveNodes('draft');
          resolve(true);
        },
        () => {
          resolve(true);
        },
        () => {
          resolve(false);
        },
        {
          title: t('you_have_unsaved_changes'),
          text: t('do_you_want_to_save_before_exiting'),
          confirmButtonText: t('exit_save_exit'),
          denyButtonText: t('exit_without_saving'),
          cancelButtonText: t('Cancel'),
        }
      );
    });
  };

  const ExitNavigation = async (type) => {
    let confirmcondition = true;
    if (!id || !user) {
      CustomAlert.warning(
        t('warning') || 'Warning',
        t('currently_not_navigate_on_draft_mode') || 'Currently not navigate on draft mode'
      );
      return;
    }
    if (type === 'exit') {
      confirmcondition = await handleExitBack();
    }
    if (confirmcondition) {
      goToProcess({
        mode: 'draft',
        view: 'swimlane',
        processId: id,
        level: currentLevel,
        parentId: currentParentId || undefined,
      });
    }
  };

  const handleFav = async () => {
    // const user_id = LoginUser ? LoginUser.id : null;
    const process_id = id ? id : null;
    const type = user ? user.type : null;

    if (!process_id || !type) {
      logger.error('Missing required fields:', { process_id, type });
      return;
    }

    const PageGroupId = ChildNodes[0]?.page_group_id;

    try {
      if (isFavorite) {
        await removeFavProcess(process_id, PageGroupId);
        setIsFavorite(false);
      } else {
        await addFavProcess(process_id, type, PageGroupId, currentParentId);
        setIsFavorite(true);
      }
    } catch (error) {
      logger.error('Favorite toggle error:', error);
    }
  };

  const navigateToVersion = (process_id, level, version) => {
    const user_id = LoginUser ? LoginUser.id : null;
    const encodedTitle = encodeURIComponent('swimlane');
    navigate(
      `/swimlane-version/${process_id}/${level}/${version}/${encodedTitle}/${user_id}/${currentParentId}`
    );
  };

  const handleVersionClick = () => {
    setShowVersionPopup(true);
  };

  const updateNodeTranslations = (nodeId, translations) => {
    const nodeToUpdate = ChildNodes.find((n) => n.id === nodeId);
    if (!nodeToUpdate) return;

    const baseId = nodeToUpdate.data?.link || nodeToUpdate.id;
    const langKey = langMap[processDefaultlanguage_id] || 'EN';

    setChiledNodes((nds) =>
      nds.map((node) => {
        const isMatch = node.id === baseId || node.data?.link === baseId || node.id === nodeId;

        if (isMatch && node.type === 'SwimlineRightsideBox' && !node.data?.isRoleGroup) {
          const newTitle = translations[langKey] || node.data?.details?.title;
          return {
            ...node,
            data: {
              ...node.data,
              translations: { ...(node.data.translations || {}), ...translations },
              details: { ...(node.data.details || {}), title: newTitle },
            },
          };
        }

        const isStandardNode =
          node.id === nodeId &&
          (node.type === 'StickyNote' ||
            node.type === 'FreeText' ||
            node.type === 'box' ||
            node.type === 'diamond' ||
            node.type === 'progressArrow');

        if (isStandardNode) {
          const newTitle = translations[langKey] || node.data.details?.title || node.data.label;

          return {
            ...node,
            data: {
              ...node.data,
              translations: { ...(node.data.translations || {}), ...translations },
              label:
                node.type === 'StickyNote' || node.type === 'FreeText' ? newTitle : node.data.label,
              details: {
                ...(node.data.details || {}),
                title:
                  node.type === 'box' || node.type === 'diamond' || node.type === 'progressArrow'
                    ? newTitle
                    : node.data.details?.title,
              },
            },
          };
        }

        if (node.data?.isRoleGroup && node.data?.roles) {
          const updatedRoles = node.data.roles.map((r) => {
            if (r.id === baseId) {
              const newName = translations[langKey] || r.name;
              return {
                ...r,
                name: newName,
                translations: { ...(r.translations || {}), ...translations },
              };
            }
            return r;
          });
          return { ...node, data: { ...node.data, roles: updatedRoles } };
        }

        return node;
      })
    );
    setHasUnsavedChanges(true);
  };

  const handleNext = (data) => {
    setrevisionData(data);
    if (data.editorialChange) {
      setShowPublishPopup(false);
      setShowEditorialPopup(true);
    }
    if (data.classificationChange) {
      setShowPublishPopup(false);
      setShowContentPopup(true);
    }
  };

  const editorialPublish = async (data) => {
    setShowEditorialPopup(false);
    const Level = `level${currentLevel}${currentParentId ? `_${currentParentId}` : ''}`;
    const payload = {
      process_id: processId,
      level: Level,
      revision_text: revisionData?.translations
        ? revisionData.translations
        : revisionData?.revisionText,
      selected_language: revisionData?.selectedLanguage,
      requested_by: LoginUser ? LoginUser.id : null,
      schedule_type: data.scheduleType,
      scheduled_date: new Date(data.date).toISOString(),
      timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
    };
    await editorialPublishAPI(payload);

    const msgT = t('editorial_change_submitted_successfully');
    const event = new CustomEvent('modelSaved', {
      detail: { message: msgT || 'Editorial change submitted' },
    });
    window.dispatchEvent(event);

    await handleExitBack();

    setTimeout(() => {
      goToProcess({
        mode: 'draft',
        view: 'swimlane',
        processId,
        level: currentLevel,
        parentId: currentLevel === 0 ? undefined : currentParentId,
      });
    }, 2000);
  };

  const handleContentSubmit = async (data) => {
    setShowContentPopup(false);
    const processPath = buildProcessPath({
      mode: 'draft',
      view: 'swimlane',
      processId,
      level: currentLevel,
      parentId: currentLevel === 0 ? undefined : currentParentId,
    });

    const processLink = `${window.location.origin}${processPath}`;
    const Level = `level${currentLevel}${currentParentId ? `_${currentParentId}` : ''}`;
    const payload = {
      process_id: processId,
      level: Level,
      revision_text: revisionData?.translations
        ? revisionData.translations
        : revisionData?.revisionText,
      selected_language: data.emailLanguage,
      requested_by: LoginUser ? LoginUser.id : null,
      owner_id: data?.owner?.id || null,
      cc_architect: data.ccRoles.architect,
      cc_manager: data.ccRoles.manager,
      cc_modeler: data.ccRoles.modeler,
      planned_publish_date: new Date(data.date).toISOString(),
      timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
      personal_message: data.personalMessage,
      process_title: title,
      process_link: processLink,
    };
    await contentChangeRequest(payload);

    const msgT = t('content_submitted_successfully');
    const event = new CustomEvent('modelSaved', {
      detail: { message: msgT || 'Content change requested' },
    });
    window.dispatchEvent(event);

    await handleExitBack();

    setTimeout(() => {
      goToProcess({
        mode: 'draft',
        view: 'swimlane',
        processId,
        level: currentLevel,
        parentId: currentLevel === 0 ? undefined : currentParentId,
      });
    }, 2000);
  };

  const handleSavePublish = async () => {
    if (currentLevel !== 0) {
      try {
        const response = await checkParentPublishRecords(currentParentId, processId);

        if (response?.status === false) {
          CustomAlert.warning(t('warning'), t('publish_all_parent_models_first'));
          return false;
        }
      } catch (error) {
        logger.error('filter draft error', error);
      }
    }
    const latestData = await refetch();
    const contact = latestData?.contact_info;

    if (!contact || Object.values(contact).every((list) => !list || list.length === 0)) {
      CustomAlert.info(
        t('information'),
        t(
          'please_assign_process_owner_process_domain_owner_and_process_modeler_to_publish_the_model'
        )
      );
      return;
    }

    setShowPublishPopup(true);
  };

  const handleSaveVersionDetails = (payload) => {
    setversionPopupPayload(payload);
    setShowVersionPopup(false);
    setHasUnsavedChanges(true);
  };

  const handleLanguageSwitch = async (langId) => {
    if (!hasUnsavedChanges) {
      fetchNodes(langId);
      return;
    }

    const shouldProceed = await new Promise((resolve) => {
      CustomAlert.confirmLanguageSwitch(
        async () => {
          await handleSaveNodes('draft');
          fetchNodes(langId);
          resolve(true);
        },
        () => {
          fetchNodes(langId);
          setHasUnsavedChanges(false);
          resolve(true);
        },
        () => {
          resolve(false);
        },
        {
          title: t('save_changes_before_switching_language'),
          confirmButtonText: t('yes_save_switch'),
          cancelButtonText: t('no_discard_changes'),
        }
      );
    });

    if (shouldProceed) {
      fetchNodes(langId);
    }
  };

  const approveProcess = async () => {
    CustomAlert.confirm(
      t('confirmation'),
      t('do_you_want_to_approve_the_process_and_inform_the_modeler_to_publish_it'),
      async () => {
        try {
          await api.approveProcessAPI({
            process_id: id,
            level: `level${currentLevel}${currentParentId ? `_${currentParentId}` : ''}`,
            user_id: LoginUser?.id,
          });
          CustomAlert.toast(t('process_approved_successfully'));
          window.location.reload();
        } catch (e) {
          logger.error(e);
          CustomAlert.error(
            t('error') || 'Error',
            t('failed_to_approve_process') || 'Failed to approve process.'
          );
        }
      }
    );
  };

  const requestChange = async (reason) => {
    try {
      await api.requestChangeAPI({
        process_id: id,
        level: `level${currentLevel}${currentParentId ? `_${currentParentId}` : ''}`,
        user_id: LoginUser?.id,
        reason: reason,
      });
      CustomAlert.toast(t('change_requested_successfully'));
      window.location.reload();
    } catch (e) {
      logger.error(e);
      CustomAlert.error(
        t('error') || 'Error',
        t('failed_to_request_change') || 'Failed to request change.'
      );
    }
  };

  const handleCreateRole = async (name, translations) => {
    try {
      const response = await api.createRole({
        Process_id: id,
        user_id: user && user.id,
        name: name,
        translations: translations,
        login_user_id: LoginUser?.id,
      });

      if (response.status) {
        const rolesData = await api.getexistingrole(null, user?.id, id);
        const parsedData = Array.isArray(rolesData.AllexistingRole)
          ? rolesData.AllexistingRole
          : [];
        setLinkexistingRole(parsedData);
        CustomAlert.toast(t('role_created_successfully'));
      }
    } catch (error) {
      CustomAlert.error(
        t('error') || 'Error',
        t('failed_to_create_role') || 'Failed to create role.'
      );
    }
  };

  return {
    fetchExistingRoles,
    handleNodeClick,
    handleClosePopup,
    handleSaveNodes,
    saveDetails,
    translation,
    handleDeleteNode,
    handleNodeRightClick,
    handleSaveRoleGroup,
    switchNodeType,
    linkExistingmodel,
    AddexistingRole,
    handleCheckboxChange,
    handleexistingroleCheckboxChange,
    handleSaveExistingRole,
    saveSelectedNodes,
    removeExistingLink,
    openExistingModel,
    handleTextSubmit,
    UpdateText,
    handlePopupAction,
    handleAssignOwnerAction,
    deleteEdge,
    onReconnect,
    onEdgeClick,
    handleOptionClick,
    handleContextMenu,
    handleExitBack,
    ExitNavigation,
    handleFav,
    navigateToVersion,
    handleVersionClick,
    updateNodeTranslations,
    handleNext,
    editorialPublish,
    handleContentSubmit,
    handleSavePublish,
    handleSaveVersionDetails,
    handleLanguageSwitch,
    approveProcess,
    requestChange,
    handleCreateRole,
  };
};
